import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from './Icon';
import InvalidFeedback from './InvalidFeedback';

export interface FormikRawInputProps {
  id: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  ariaDescribedby?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  type?: string;
  max?: number;
  classInput?: string;
  inputProps?: React.HTMLAttributes<HTMLInputElement>;
  icon?: string;
  idIcon?: string;
  swap?: boolean;
  iconProps?: React.HTMLAttributes<HTMLSpanElement>;
  idFeedback?: string;
  prevText?: string;
  nextText?: string;
  disabled?: boolean;
  required?: boolean;
  meta?: {
    touched?: boolean;
    error?: string;
  };
}

export function FormikRawInput({
  id,
  name,
  value,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  ariaDescribedby,
  inputRef,
  type = 'text',
  max,
  classInput,
  inputProps = {},
  icon,
  idIcon,
  swap = false,
  iconProps = {},
  idFeedback,
  prevText,
  nextText,
  disabled,
  required,
  meta: { touched, error } = {}
}: FormikRawInputProps) {
  return (
    <div className="input-group has-validation">
      {icon && swap && (
        <span className="input-group-text" id={idIcon}>
          <Icon icon={icon} {...iconProps} />
        </span>
      )}
      {prevText && <span className="input-group-text">{prevText}</span>}
      <input
        ref={inputRef}
        id={id}
        name={name}
        max={max}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        type={type}
        className={classNames(
          'form-control',
          touched && error && 'is-invalid',
          touched && !error && 'is-valid',
          classInput
        )}
        {...(ariaDescribedby && {
          'aria-describedby': ariaDescribedby
        })}
        {...inputProps}
      />
      {nextText && <span className="input-group-text">{nextText}</span>}
      {icon && !swap && (
        <span className={classNames('input-group-text', touched && error && 'border border-danger')} id={idIcon}>
          <Icon icon={icon} {...iconProps} />
        </span>
      )}
      <InvalidFeedback id={idFeedback} message={touched && error ? error : ''} />
    </div>
  );
}

FormikRawInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  ariaDescribedby: PropTypes.string,
  placeholder: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  type: PropTypes.string,
  max: PropTypes.string,
  classInput: PropTypes.string,
  inputProps: PropTypes.object,
  icon: PropTypes.string,
  idIcon: PropTypes.string,
  swap: PropTypes.bool,
  iconProps: PropTypes.object,
  idFeedback: PropTypes.string,
  prevText: PropTypes.string,
  nextText: PropTypes.string,
  disabled: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

export default FormikRawInput;
